/* Manufacturer SKU sync for Shopify Empire v13
   Reads variant metafields from the Liquid data map:
   <span data-manufacturer-sku-map='{"123":"ABC"}'></span>

   Does not modify Shopify/Empire product logic.
   It only updates the visible Manufacturer SKU row on variant change.
*/
(function () {
  'use strict';

  var MAP_SELECTOR = '[data-manufacturer-sku-map]';
  var TARGET_SELECTOR = '.manufacturer-sku .value, .manufacturer-sku .product-meta__sku-value';
  var ROW_SELECTOR = '.manufacturer-sku';
  var VARIANT_SELECTION_SELECTOR = 'variant-selection, [data-variant-selection]';
  var VARIANT_VALUE_SELECTOR = '[data-variants], form[action*="/cart/add"] [name="id"], form.product-form [name="id"], [data-product-form] [name="id"]';

  function readSkuMap() {
    var el = document.querySelector(MAP_SELECTOR);
    if (!el) return {};

    try {
      return JSON.parse(el.getAttribute('data-manufacturer-sku-map') || '{}') || {};
    } catch (error) {
      console.warn('[Manufacturer SKU] Could not parse variant SKU map.', error);
      return {};
    }
  }

  function normaliseVariantId(value) {
    if (!value || value === 'not-selected' || value === 'unavailable' || value === 'false') return null;
    return String(value);
  }

  function getCurrentVariantId() {
    var variantSelection = document.querySelector(VARIANT_SELECTION_SELECTOR);
    var fromVariantSelection = variantSelection && (
      variantSelection.getAttribute('variant') ||
      variantSelection.getAttribute('data-variant') ||
      variantSelection.value
    );

    var variantValueEl = document.querySelector(VARIANT_VALUE_SELECTOR);
    var fromVariantValueEl = variantValueEl && variantValueEl.value;

    var fromUrl = new URLSearchParams(window.location.search).get('variant');

    var fromAnalytics = window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.selectedVariantId;

    return normaliseVariantId(fromVariantSelection) ||
      normaliseVariantId(fromVariantValueEl) ||
      normaliseVariantId(fromUrl) ||
      normaliseVariantId(fromAnalytics);
  }

  function renderManufacturerSku(variantId) {
    var target = document.querySelector(TARGET_SELECTOR);
    if (!target) return;

    var skuMap = readSkuMap();
    var sku = skuMap[String(variantId || '')] || '';
    var row = target.closest(ROW_SELECTOR);

    target.textContent = sku;
    if (row) row.style.display = sku ? '' : 'none';
  }

  function renderFromCurrentState() {
    renderManufacturerSku(getCurrentVariantId());
  }

  function handleVariantChange(event) {
    var detail = event && event.detail ? event.detail : {};
    var variantId = detail.variant && detail.variant.id ? detail.variant.id : detail.id;

    if (variantId) {
      renderManufacturerSku(variantId);
      return;
    }

    window.requestAnimationFrame(renderFromCurrentState);
  }

  function bindVariantSelectionEvents(scope) {
    scope = scope || document;
    var nodes = [];

    if (scope.matches && scope.matches(VARIANT_SELECTION_SELECTOR)) {
      nodes.push(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(VARIANT_SELECTION_SELECTOR).forEach(function (node) {
        nodes.push(node);
      });
    }

    nodes.forEach(function (node) {
      if (node.dataset.manufacturerSkuBound === 'true') return;
      node.dataset.manufacturerSkuBound = 'true';

      // Empire v13 dispatches variant-change from the variant-selection element.
      // It is not guaranteed to bubble, so bind directly to the element.
      node.addEventListener('variant-change', handleVariantChange);

      // Harmless fallbacks for other Shopify/theme event names.
      node.addEventListener('variant:change', handleVariantChange);
      node.addEventListener('product:variant-change', handleVariantChange);
    });
  }

  function patchHistoryMethod(methodName) {
    var original = window.history[methodName];
    if (!original || original.__manufacturerSkuPatched) return;

    window.history[methodName] = function () {
      var result = original.apply(this, arguments);
      window.requestAnimationFrame(renderFromCurrentState);
      return result;
    };

    window.history[methodName].__manufacturerSkuPatched = true;
  }

  function init() {
    bindVariantSelectionEvents(document);
    renderFromCurrentState();

    document.addEventListener('change', function (event) {
      if (
        event.target &&
        (
          (event.target.matches && event.target.matches(VARIANT_VALUE_SELECTOR)) ||
          (event.target.closest && event.target.closest('[data-product-option], [data-variant-selection], variant-selection'))
        )
      ) {
        window.requestAnimationFrame(renderFromCurrentState);
      }
    }, true);

    document.addEventListener('input', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-product-option], [data-variant-selection], variant-selection')) {
        window.requestAnimationFrame(renderFromCurrentState);
      }
    }, true);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          bindVariantSelectionEvents(node);
          if ((node.matches && node.matches(MAP_SELECTOR)) || (node.querySelector && node.querySelector(MAP_SELECTOR))) {
            window.requestAnimationFrame(renderFromCurrentState);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('popstate', renderFromCurrentState);
    patchHistoryMethod('replaceState');
    patchHistoryMethod('pushState');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
